import { HasValidatorFn } from './has-validator-fn';
import { Section } from './section';
import { hasSectionValidatorFn } from './section-composition-fns';

/**
 * Transforms RawColumn to Column
 * @param column - the db or raw column
 */
export const SectionFactory = <T extends Section>(section: T): T & HasValidatorFn => {
  return Object.assign(section, hasSectionValidatorFn());
};
